<!--  -->
<template>
  <div class="diaLog">
    <van-dialog
      v-model="show"
      title="温馨提示"
      message="确认取消订单吗？"
      cancel-button-text="考虑一下"
      confirm-button-text="不考虑了"
      :close-on-click-overlay="true"
      @confirm="confirm"
      show-cancel-button>
      <!-- <p>确认取消订单吗？</p> -->
    </van-dialog>
  </div>
</template>

<script>
import { reqCancelOrder } from '@/api/personal/orderController';

export default {
  props: {
    logType: {
      type: String,
    },
    orderID: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    confirm() {
      this.cancelOrder();
    },
    // 取消请求接口
    async cancelOrder() {
      try {
        const res = await reqCancelOrder(this.orderID);
        if (res.code === 0) {
          this.$toast('取消订单成功！');
          this.selectType();
        } else {
          this.$toast(`取消失败！${res.msg}`);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 判断调用的组件
    selectType() {
      // 判断调用的组件
      switch (this.logType) {
        case 'allIndent':
          // 全部订单页面
          this.$emit('clearAllList');
          break;
        case 'unpaidIndent':
          // 未支付页面
          this.$emit('clearUnList');
          break;
        case 'detailIndent':
          // 订单详情页
          this.$emit('clearDetailList');
          break;
        default:
      }
    },
  },
};

</script>
